import { render, staticRenderFns } from "./MediaReviewVideoSessionOverview.vue?vue&type=template&id=64e4f9fa&scoped=true&"
import script from "./MediaReviewVideoSessionOverview.vue?vue&type=script&lang=js&"
export * from "./MediaReviewVideoSessionOverview.vue?vue&type=script&lang=js&"
import style0 from "./MediaReviewVideoSessionOverview.vue?vue&type=style&index=0&id=64e4f9fa&scoped=true&lang=css&"
import style1 from "./MediaReviewVideoSessionOverview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4f9fa",
  null
  
)

export default component.exports